import React from "react";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class SwitchInput extends React.Component {
    state = { checked: true }
    componentWillMount() {
    }

    checkSettings(param) {
        if (this.props.settings) {
            return this.props.settings[param]
        } else {
            return false
        }
    }

    changeValue = (target) => {
        // console.log(target.value)
        // let newValue = false
        // if(target.value == 'on' || target.value == true){
        //     newValue = true
        // }
        let newValue = this.props.data != null ? this.props.data : false
        newValue = !newValue
        // if(this.props.header.information.invert){
        //     newValue = !newValue
        // }

        // console.log(newValue)
        this.props.changeValue(this.props.header.key, newValue, this.props.extra)
        // this.setState({ checked: !this.state.checked })
    }

    render() {
        let info = this.props.header?.information
        let data = this.props.data != null ? this.props.data : false
        return (
            <div className='mt-1 '>
                <label className="switch">
                    <input type="checkbox"
                        name={this.props.header.key}
                        id={this.props.header.key}
                        checked={this.props.header.information.invert ? !data : data}
                        disabled={info?.disabled}
                        onChange={e => this.changeValue(e.target)} />
                    <span className="slider round"></span>
                </label>
            </div>
        );
    }
}

export default SwitchInput;
